// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Footer-components-FooterMenu----footer-menu-module---container---2EJgV","main":"src-components-Footer-components-FooterMenu----footer-menu-module---main---2PCLk","sub":"src-components-Footer-components-FooterMenu----footer-menu-module---sub---QSf2B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/components/FooterMenu/footer-menu.module.less
// module id = 260
// module chunks = 114276838955818